/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVR4nMVVO07DQBC1aABBQVIGxAFAnMFVJEfOzm6EnBmFwgTugBDcgwtAByRRLhAo+RcgJUAHNKkSBC0CjYHYJsG7SQErrbSF972d92aeLes/l+d5aVC0BpJqQlELFL7y/jpXAYpl1y2lRgGeBIXboPAZFL0nbSGpKyRu8R0jcADKgKRTHTD8JFJ4lc9784nghcLKHCh6GhYcetXgo+t6s7/LIuliVHAIKzmzfX+iX5pA84TLEo+y2eyUbdvTQtFxMhFu/nx9WmuoLO5YljXGm88642PdJSSua8uXuPtNICTuGfixGsojqWagbb1HoLBu8H0loj/d6y9QIySghsH3rYhE9GLwovPQA323MeZQBCDxrkdgUDE3TZTg1sC0dsTktsGDmtEZqBoQvDngLQixvMhnPQEdRvKnWNaXTAGJEfinyX5s0Hg4DAj2hcIDg4boSOnPxKaZI1dT8nVoMt5oOmijL4s4oDioEi51czlviXdStULiycCw48VRy5FrojEM1v2B/ycDwUPDKcOvGB4cL7U/nKhcHLlGxivssOaO44wbgcclK6U4FYM5kdjkiQ+mns8KK9yKfd3y1+sDprXdk8xh4REAAAAASUVORK5CYII=)
 */
export const CircleWarningIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm1.44-15.94L13.06 14a1.06 1.06 0 0 1-2.12 0l-.38-6.94a1 1 0 0 1 1-1.06h.88a1 1 0 0 1 1 1.06Zm-.19 10.69a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
